import * as React from 'react'
import { getContractType } from '@/app/services/contract/contractTypeResolver'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import TableRadio from '@/modules/drivers/shared/tableItems/TableRadio'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import useFormatDate from '@/modules/drivers/hooks/useFormatDate'
import {
  CivilLawCostsOfIncomeType,
  ContractModel,
  TaxCostsType,
} from '@/modules/drivers/types/contracts'
import { getContractTypeName } from '@/app/common/converters/contractTypeToTextConverter'
import { ContractType } from '@/app/constants/contractType'

export const DriverContractDetailsRow = ({
  contract,
  selectedIds,
  toggleId,
  actualAnnexId,
  onDoubleClick,
}: {
  contract: ContractModel
  selectedIds: number[]
  toggleId: (id: number, checked: boolean, additionalType?: string) => void
  actualAnnexId?: string
  onDoubleClick?: () => void
}) => {
  const isAnyChecked = selectedIds.length > 0
  const { t } = useLocalize()
  const yes = t('answer.yes')
  const no = t('answer.no')

  const { formatDate } = useFormatDate()

  const isChecked = selectedIds.includes(Number(contract.id))

  // Mirrors WPF DriverContractToContractAmountConverter — settlement raw values:
  // 1 = Month, 2 = Hour, 3 = ForContract
  const contractType = getContractType(contract?.type)
  const isCivilLawOrSelfEmployment =
    contractType === ContractType.CivilLawAgreement ||
    contractType === ContractType.SelfEmployment
  const settlement = Number(contract?.settlement)
  const showsMinimalRate =
    contract?.isMinimalContractRate === true &&
    (isCivilLawOrSelfEmployment
      ? settlement === 2
      : settlement === 1 || settlement === 3)

  const getKupText = () => {
    if (contractType === ContractType.CivilLawAgreement) {
      if (contract?.civilLawIncomeCosts === CivilLawCostsOfIncomeType.None) {
        return '-'
      }
      return contract?.civilLawIncomeCosts === CivilLawCostsOfIncomeType.Increased
        ? '50%'
        : '20%'
    }
    if (
      contract?.increasedTaxCosts == null ||
      contract?.increasedTaxCosts === TaxCostsType.None
    ) {
      return '-'
    }
    return contract?.increasedTaxCosts === TaxCostsType.Increased ? '300' : '250'
  }

  const [isHovered, setIsHovered] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)
  return (
    <tr
      className={`notches-border--right tw-w-fit tw-border-b hover:tw-bg-primary/10 ${isChecked ? 'selected tw-bg-primary/10' : 'tw-bg-white'}`}
      onDoubleClick={onDoubleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableRadio
        isHovered={isHovered}
        background
        disabled={isAnyChecked && !isChecked}
        checked={isChecked}
        onClick={() =>
          toggleId(
            Number(contract.id),
            !isChecked,
            contract?.isAnnex ? 'ANNEX' : 'CONTRACT',
          )
        }
      />
      {/* <TableTextRow size="small" pointer={false}>
        {contract?.isAnnex === true
          ? t('contract.annex').toString()
          : t('contract.contract').toString()}
      </TableTextRow> */}
      <TableTextRow size="small" pointer={false}>
        {formatDate(contract?.startDate) ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.endDate
          ? formatDate(contract.endDate)
          : actualAnnexId === contract?.id
            ? t('contract.ongoing')
            : '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {getContractTypeName(getContractType(contract?.type), t)}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {showsMinimalRate ? t('rate.minimal') : contract?.contractRate}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.lumpSumNightAmount ?? contract?.nightRate ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.overtimeRate ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.dutyRate ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.bonusRate ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.lumpSumAllRates ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.euWorkRate ?? '-'}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.rateSummary != null
          ? Number(contract.rateSummary).toFixed(2)
          : '-'}
      </TableTextRow>

      <TableTextRow size="small" pointer={false}>
        {contract?.includeTaxFreeAmount === true ? yes : no}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.isTaxExempt === true ? yes : no}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.isSeniorRelief === true ? yes : no}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {contract?.isPpkEnabled === true ? yes : no}
      </TableTextRow>
      <TableTextRow size="small" pointer={false}>
        {getKupText()}
      </TableTextRow>
    </tr>
  )
}
